import { render, staticRenderFns } from "./UserDataEarningsChart.vue?vue&type=template&id=1d89430a&"
import script from "./UserDataEarningsChart.vue?vue&type=script&lang=js&"
export * from "./UserDataEarningsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports